import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { FormType } from "../schemas";
import { useFilterStore, useOriginalDataStore } from "../stores";
import { formatForm } from "./formatForm";
import { ShiftType } from "../hooks";
import { DataListType } from "../types";

type Params = {
    data: DataListType[]
    code?: string;
    method: UseFormReturn<FormType>;
    shift: ShiftType[]
};

export function useShiftScheduleForm({
    data,
    code,
    method,
    shift
}: Params) {
    const { filter, setFilter } = useFilterStore();
    const { setOriginalData } = useOriginalDataStore();

    // sync code
    useEffect(() => {
        if (!code) return;
        method.setValue("code", code);

        // eslint-disable-next-line
    }, [code]);


    //   reset filter api
    useEffect(() => {
        if (filter.date_start || filter.date_end) {
            if (filter.type === "prev") {
                setFilter({ type: "now" });
            }
        }
        // eslint-disable-next-line
    }, [filter.date_start, filter.date_end]);



    // sync location
    useEffect(() => {
        if (!data || !data.length) return;

        const currentDetail = method.getValues("detail");
        if (!currentDetail?.length) return;

        method.setValue(
            "detail",
            currentDetail.map((detailItem, index) => ({
                ...detailItem,
                location_id: String(data[index]?.location_id ?? ""),
            })),
            { shouldDirty: false }
        );
    }, [data, method]);


    // handle PREVIOUS
    useEffect(() => {
        if (!data) return;

        if (filter.type !== "prev") return;

        const formatted = formatForm(data, shift, filter.shift_schedule_id);
        const currentCode = method.getValues("code");

        method.reset({
            code: currentCode,
            detail: formatted,
        });

        setOriginalData(formatted);

        // eslint-disable-next-line
    }, [data, filter.type]);
}
